import { toast } from 'react-toastify';
import { apiPayment } from '../api/apiPayment.api';
import { useState } from 'react';
import useAxiosPrivate from './useAxiosPrivate';
import { openLink } from '../utils/openLink';

export function useBindCard() {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateBindCard = async () => {
    setIsLoading(true);
    try {
      const response = await apiPayment.createBindCard(axiosPrivate);
      openLink(response.redirectUrl);
    } catch (error) {
      const message = error?.response?.data?.message || error.message;
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return { handleCreateBindCard, isLoading };
}
